// Event theme strings — swap together with theme.scss to re-brand boothy.
export default {
    title: "Jasmin & Sven",
    monogram: "J & S",
    date: "10 · 10 · 2026",
    headline: ["Knipsen.", "Teilen.", "Erinnern."],
}
